export default __webpack_public_path__ + "static/media/bakery-active.392b3c09.svg";